import PageHeaderBasic from "components/PageHeaderBasic"

export default function PageHeaderBasicDynamic({ blok }) {
  return <PageHeaderBasic heading={blok.heading} subheading={blok.content} />
}
